Common.Models.Browser = Backbone.Model.extend({
	defaults: {
		browser: null,
		version: null,
		os: null,
		isRestricted: false,				// этот атрибут определяет, считается браузер устаревшим или нет
		isQuirksMode: false					// этот атрибут определяет, включен режим совместимости в ie>7 или нет
	},

	restrictions: {
		Chrome: 7,
		Firefox: 3.5,
		IE: 10,
		Opera: 10,
		Safari: 5,
		Netscape: 0,
		Konqueror: 0
	},

	dataBrowser: [{
		string: navigator.userAgent,
		subString: 'OPR',
		versionSearch: 'OPR',
		identity: 'Opera'
	}, {
		string: navigator.userAgent,
		subString: 'Chrome',
		identity: 'Chrome'
	}, {
		string: navigator.userAgent,
		subString: 'OmniWeb',
		versionSearch: 'OmniWeb/',
		identity: 'OmniWeb'
	}, {
		string: navigator.userAgent,
		subString: 'CriOS',
		identity: 'Chrome',
		versionSearch: 'CriOS'
	}, {
		string: navigator.vendor,
		subString: 'Apple',
		identity: 'Safari',
		versionSearch: 'Version'
	}, {
		prop: window.opera,
		identity: 'Opera',
		versionSearch: 'Version'
	}, {
		string: navigator.vendor,
		subString: 'iCab',
		identity: 'iCab'
	}, {
		string: navigator.vendor,
		subString: 'KDE',
		identity: 'Konqueror'
	}, {
		string: navigator.userAgent,
		subString: 'Firefox',
		identity: 'Firefox'
	}, {
		string: navigator.vendor,
		subString: 'Camino',
		identity: 'Camino'
	}, {
		string: navigator.userAgent,
		subString: 'Netscape',
		identity: 'Netscape'
	}, {
		string: navigator.userAgent,
		subString: 'MSIE',
		identity: 'IE',
		versionSearch: 'MSIE'
	}, {
		string: navigator.userAgent,
		subString: 'Trident',
		identity: 'IE',
		versionSearch: 'rv'
	}, {
		string: navigator.userAgent,
		subString: 'Gecko',
		identity: 'Mozilla',
		versionSearch: 'rv'
	}, {
		string: navigator.userAgent,
		subString: 'Mozilla',
		identity: 'Netscape',
		versionSearch: 'Mozilla'
	}],

	dataOS: [{
		string: navigator.platform,
		subString: 'Win',
		identity: 'Windows'
	}, {
		string: navigator.platform,
		subString: 'Mac',
		identity: 'Mac'
	}, {
		string: navigator.userAgent,
		subString: /ip(hone|ad|od)/i,
		identity: 'iOS'
	}, {
		string: navigator.platform,
		subString: 'Linux',
		identity: 'Linux'
	}],


	initialize: function() {
		// Ссылка на эту модель будет доступна в самом приложении
		Common.Browser = this;

		var browser = this.searchString(this.dataBrowser),
			version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion),
			minVersion = this.restrictions[browser];

		this.set({
			browser: browser,
			version: version,
			os: this.searchString(this.dataOS),
			isRestricted: (minVersion === 0) || (minVersion > version),
			isQuirksMode: this.checkQuirksMode(browser, version)
		});
	},


	isRestricted: function() {
		return this.get('isRestricted');
	},

	isQuirksMode: function() {
		return this.get('isQuirksMode');
	},

	searchString: function (data) {
		for (var i = 0, max = data.length; i < max; i++) {
			var dataString = data[i].string,
				dataProp = data[i].prop;

			this.versionSearchString = data[i].versionSearch || data[i].identity;

			if (dataString) {
				if ((typeof data[i].subString) === 'string') {
					if (dataString.indexOf(data[i].subString) != -1) {
						return data[i].identity;
					}
				} else {
					if (data[i].subString.test(dataString)) {
						return data[i].identity;
					}
				}
			} else if (dataProp) {
				return data[i].identity;
			}
		}

		return null;
	},

	searchVersion: function (dataString) {
		var index = dataString.indexOf(this.versionSearchString);

		if (index == -1) {
			return null;
		}

		return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
	},

	checkQuirksMode: function(browser, version) {
		if (browser === 'IE' && version === 7) {
			return /trident\/(\d\.\d)/i.test(navigator.userAgent);		// В IE7 userAgent не содержит информацию о версии Trident. В режиме совместимости IE прикидывается 7-м, но Trident не скрывает.
		}

		return false;
	}
});
